import createSvgIcon from '../Utils/CreateSvgIcon';

export const Image = createSvgIcon(
  <path
    d="M20 6L4 6V17L8 9L12 15L15 12L20 17.8333L20 6ZM4 4H2V6V18V20H4H20H22L22 18L22 6V4L20 4L4 4ZM19 9C19 10.1046 18.1046 11 17 11C15.8954 11 15 10.1046 15 9C15 7.89543 15.8954 7 17 7C18.1046 7 19 7.89543 19 9Z"
    fillRule="evenodd"
  />,
  'Image',
);
